exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.error[data-v-6eb122e2] {\n    color: rgba(255, 0, 0, 0.6) !important;\n}\n.error-ctrl[data-v-6eb122e2] {\n    background-color: rgba(255, 0, 0, 0.16) !important;\n}\n", ""]);

// exports
